import { render, staticRenderFns } from "./EditBudgetDetails.vue?vue&type=template&id=27d8c662&scoped=true"
import script from "./EditBudgetDetails.vue?vue&type=script&lang=js"
export * from "./EditBudgetDetails.vue?vue&type=script&lang=js"
import style0 from "./EditBudgetDetails.vue?vue&type=style&index=0&id=27d8c662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d8c662",
  null
  
)

export default component.exports